<template>
  <section class="business-team-container content-max-width">
    <div class="filter flex">

      <div class="custom-radio"
        v-for="(item, index) of filter" :key="index">
        <input type="radio" name="filter" :value="item.value" v-model="payload.filter">
        <span>{{ item.label }}</span>
      </div>

    </div>

    <div class="team flex">
      <article v-for="(person, index) of team" :key="index">
        <div class="wrap js-inline-popup" @click="toggleInfo(index)">
            <div class="image">
              <img :src="person.preview_image" :alt="person.name">
            </div>
            <div class="content">
              <h3>{{ person.name }}</h3>
              <h4>{{ person.title }}</h4>
              <a :href="`mailto:${person.email}`">{{ person.email }}</a>
              <span>Read Bio</span>
            </div>
        </div>
      </article>
    </div>

    <div
      class="load-more content-max-width"
      @click="loadTeam(true)"
      :disabled="isDisabled"
      v-if="payload.nextUrl"
    >
      <a class="load-more-btn button large blue-border">Load More</a>
    </div>

    <div :class="{ 'open': isModalOpen }" class="team-popup">
      <span class="bg" @click="closeModal"></span>
      <div class="content-container">
        <button class="close-button" @click="closeModal"></button>

        <div class="flex flex-between">
          <div class="image">
              <img :src="activePerson.preview_image" :alt="activePerson.name">
          </div>
          <div class="content">
            <div class="info">
              <h3>{{ activePerson.name }}</h3>
              <h4>{{ activePerson.title }}</h4>
              <a :href="`mailto:${activePerson.email}`">{{ activePerson.email }}</a>
            </div>
            <div class="wysiwyg">
              <div v-html="activePerson.description "></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  props: {
    filter: Array,
    url: String
  },
  data () {
    return {
      team: [],
      activePerson: {},
      isModalOpen: false,
      isDisabled: false,
      payload: {
        filter: this.filter[0].value,
        page: 1,
        nextUrl: null
      }
    };
  },
  watch: {
    'payload.filter' () {
      this.loadTeam()
    }
  },
  mounted() {
    this.loadTeam();
  },
  methods: {
    loadTeam (isLoadMore = false) {
      this.$store.commit('setLoading', true)
      this.isDisabled = true

      let url = (! isLoadMore)
        ? this.url + '?page=1'
        : this.payload.nextUrl

      if (this.payload.filter) {
        url += '&section_item_ids[]=' + this.payload.filter
      }

      window.axios.get(url)
        .then((response) => {
          this.team = (isLoadMore)
            ? this.team.concat(response.data.data)
            : response.data.data

          this.payload.page = response.data.meta.current_page
          this.payload.nextUrl = response.data.links.next
        })
        .catch((error) => {
          console.log('prodd error', error)
          this.$store.commit('setPopup', {
            content: '<p>Sorry, the list could not be loaded.</p>',
            open: true
          })
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
    },

    toggleInfo (index) {
      this.activePerson = this.team[index]
      this.isModalOpen = !this.isModalOpen
    },

    closeModal () {
      this.activePerson = {}
      this.isModalOpen = !this.isModalOpen
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/business-team/Index.vue